import { useState } from 'react'
import { Header } from '@/components/DashboardComponents'
import { Button, RoundIconButton } from '@/form/FormComponents'
import { useNavigate, useLoaderData } from 'react-router'
import { GenericEmptyListPlaceholder } from '@/DashboardLayout'
import { Modal, ModalContent, ModalButtons, useModal, useErrorModal } from '@/components/Modal'
import { useMenu } from '@/components/Menu'
import { Icon } from '@/components/Icon'
import { deleteScenario, restoreScenario, deleteAllTrashedScenarios } from '@/data/ScenarioData'

export function TrashedScenarios() {
  const navigate = useNavigate();
  const scenarios = useLoaderData().data.value;

  const [openErrorModal] = useErrorModal();

  function handleDeleteScenario({ scenario }) {
    openDeleteScenarioModal({ scenario_id: scenario._id });
  }

  const [openDeleteScenarioModal] = useModal(({ context, closeModal, setLoading }) => {
    function submitDeleteScenario() {
      setLoading(true);
  
      deleteScenario({ id: context.scenario_id }).then(function(data) {
        closeModal();
        navigate('.', { replace: true });
      }).catch(function(error) {
        console.error(error);
        closeModal();
        openErrorModal();
      });
    }

    return (
      <Modal title="Delete forever?">
        <ModalContent>
          The item will be deleted and you won't be able to restore it.
        </ModalContent>
        <ModalButtons>
          <Button text="Cancel" className="hollow" onClick={closeModal}/>
          <Button text="Confirm" className="destructive" onClick={submitDeleteScenario}/>
        </ModalButtons>
      </Modal>
    )
  });

  function handleRestoreScenario({ scenario }) {
    restoreScenario({ id: scenario._id }).then(function(data) {
      navigate('.', { replace: true });
    }).catch(function(error) {
      console.error(error);
    });
  }

  const [openClearTrashModal] = useModal(({ closeModal, setLoading }) => {
    function submitClearTrash() {
      setLoading(true);
      
      deleteAllTrashedScenarios().then(function(data) {
        closeModal();
        navigate('.', { replace: true });
      }).catch(function(error) {
        console.error(error);
        closeModal();
        openErrorModal();
      });
    }
    
    return (
      <Modal title="Delete forever?">
        <ModalContent>
          All items in the trash will be deleted forever. You can't undo this.
        </ModalContent>
        <ModalButtons>
          <Button text="Cancel" className="hollow" onClick={closeModal}/>
          <Button text="Empty trash" className="destructive" onClick={submitClearTrash}/>
        </ModalButtons>
      </Modal>
    )
  });

  return (
    <>
      <Header title="Trash" no_shadow={true}></Header>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <div className="scenario_list full_page_list" columns="1">
          <div className="scenario_list_header_banner scroller_shadow_offset_height">
            <div className="callout_hint_box">
              <div>
                <div><Icon name="trash-can-outline"/></div>
                <div>Items in the trash will be deleted forever after 30 days.</div>
                <div className="callout_small_button">
                  <Button text="Empty trash" className="hollow small" onClick={openClearTrashModal} disabled={scenarios.length == 0}/>
                </div>
              </div>
            </div>
          </div>
          <div className="scenario_list_header">
            <div></div>
            <div>Title</div>
            <div>Date trashed</div>
            <div></div>
          </div>
          {scenarios.sort((a, b) => b.trashed_date - a.trashed_date).map((scenario) => <ScenarioTrashItem key={scenario._id} scenario={scenario} handleDeleteScenario={handleDeleteScenario} handleRestoreScenario={handleRestoreScenario}/>)}
        </div>
        {scenarios.length == 0 ? <GenericEmptyListPlaceholder text="Nothing in trash" icon="trash-can-outline"/> : null}
      </div>
    </>
  )
}

function ScenarioTrashItem({scenario,handleDeleteScenario,handleRestoreScenario}) {
  const { handleContextMenu, handleOnClick } = useMenu({
    menuItems: [
      {
        label: 'Restore',
        icon: 'history',
        onClick: () => handleRestoreScenario({ scenario }),
      },
      {
        label: 'Delete forever',
        icon: 'delete-forever-outline',
        onClick: () => handleDeleteScenario({ scenario }),
      },
    ]
  });

  return (
    <div className="scenario_item not_clickable" onContextMenu={handleContextMenu} tabIndex={0}>
      <div className="item_icon">
        <Icon name="forum-outline"/>
      </div>
      <div className="item_title">{scenario.data.title}</div>
      <div className="item_date">{(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(scenario.trashed_date))}</div>
      <div className="item_more">
        <RoundIconButton icon="dots-vertical" className="small" onClick={handleOnClick} />
      </div>
    </div>
  )

}